var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { ERevampReportReducers } from "@adapters/presenters/action-interfaces/Reports/common/CommonReportInterfaces";
import { PNL_REPORT_DATA, PNL_SUMMARIZE, LONG_TERM_QUANTITY, PNL_SEARCH, STOCK_INDEX, } from "@redux/interfaces/Reports/CoreReports/iProfitAndLoss";
import commonOnePlatFormReducer, { CommonOnePlatFormInitState, } from "@redux/reducers/common/commonReducer";
import { combineReducers } from "redux";
var initState = {
    pnlData: {
        pnLSummary: {
            totalPnl: "0",
            totalPnlChangePercent: "0",
            realisedPnl: "0",
            realisedPnlChangePercent: "0",
            unrealisedPnl: "0",
            unrealisedPnlChangePercent: "0",
            closePriceDate: "",
            totalMarketValue: "",
            totalClosingCostValue: "",
            totalSellCostValue: "",
            editableCount: 0,
            totalInvestment: "0",
            totalSellValue: "0",
            daysPnLChange: "0",
        },
        pnLDetails: [],
    },
    pnlSummarize: false,
    search: "",
    longTermQuantity: false,
    selectedStockIndex: undefined,
};
var ProfitAndLossReducer = function (state, action) {
    if (state === void 0) { state = initState; }
    switch (action.type) {
        case PNL_REPORT_DATA:
            return __assign(__assign({}, state), { pnlData: action.payload.pnlData });
        case PNL_SUMMARIZE:
            var newSummarizeState = __assign(__assign({}, state), { pnlSummarize: action.payload.pnlSummarize });
            return newSummarizeState;
        case LONG_TERM_QUANTITY:
            var newState = __assign(__assign({}, state), { longTermQuantity: action.payload.longTermQuantity });
            return newState;
        case PNL_SEARCH:
            return __assign(__assign({}, state), { search: action.payload.search });
        case STOCK_INDEX:
            return __assign(__assign({}, state), { selectedStockIndex: action.payload.selectedStockIndex });
        default:
            return state;
    }
};
export default combineReducers({
    reducersData: ProfitAndLossReducer,
    commonData: function (state, action) {
        if (state === void 0) { state = new CommonOnePlatFormInitState(); }
        return commonOnePlatFormReducer(state, action, ERevampReportReducers.PNL);
    },
});
